import { createReducer } from '@reduxjs/toolkit';

import LoadingStatus from '@libs/loading-status';

import {
  CONTRACT_PROGRESS_COMPLETION_FAILURE,
  CONTRACT_PROGRESS_COMPLETION_REQUEST,
  CONTRACT_PROGRESS_COMPLETION_SUCCESS,
  CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST,
} from '@app/store/actionTypes';

const initialState: LoadingStatus = LoadingStatus.IDLE;

const reducer = createReducer<LoadingStatus>(initialState, (builder) =>
  builder
    .addCase(CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST, () => LoadingStatus.IDLE)
    .addCase(CONTRACT_PROGRESS_COMPLETION_REQUEST, () => LoadingStatus.PENDING)
    .addCase(CONTRACT_PROGRESS_COMPLETION_SUCCESS, () => LoadingStatus.SUCCEEDED)
    .addCase(CONTRACT_PROGRESS_COMPLETION_FAILURE, () => LoadingStatus.FAILED)
);

export default reducer;
